import React from "react";
import PbSideMenuProps from "./PbSideMenuProps.type";

import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

const halfSpin = keyframes`
  from {
    transform: rotate(0deg)
  }
  to {
    transform: rotate(180deg)
  }
`;

const backHalfSpin = keyframes`
  from {
    transform: rotate(180deg)
  }
  to {
    transform: rotate(0deg)
  }
`;

const OpenArrowRow = styled.div((props: { isopen: boolean }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: props.isopen ? "flex-end" : "center",
  transition: "all 1s ease-out",
  "@media (max-width: 768px)": {
    justifyContent: props.isopen ? "flex-start" : "center",
  },
  zIndex: "100"
}));

const OpenMenuArrow = styled(DoubleArrowIcon)((props: { isopen: boolean }) => ({
  height: "25px",
  width: "25px",
  backgroundColor: "#E1E1E1",
  borderRadius: "99999px",
  transform: props.isopen ? "rotate(180deg)" : "",
  animation: props.isopen ? `${halfSpin} 0.3s` : `${backHalfSpin} 0.3s`,
  zIndex: 2,
  "@media (max-width: 768px)": {
    transform: props.isopen ? "rotate(270deg)" : "rotate(90deg)",
    bottom: "0",
    right: "0",
  },
  transition: "all 1s ease-out",
  margin: "10px",
}));

const SideMenu = styled.div(
  (props: {
    isopen: boolean;
    position?: { top: string; left: string };
    dimensions?: {
      desktop: { width: string; height: string };
      mobile: { width: string; height: string };
    };
  }) => ({
    position: "fixed",
    top: props.position ? props.position.top : "5vh",
    left: props.position ? props.position.left : 0,
    height: props.dimensions ? props.dimensions.desktop.height : "95vh",
    transition: "width 0.3s",
    width: props.isopen
      ? props.dimensions
        ? props.dimensions.desktop.width
        : "250px"
      : "64px",
    "@media (max-width: 768px)": {
      width: props.dimensions ? props.dimensions.mobile.width : "100vw",
      height: props.isopen
        ? "fit-content"
        : props.dimensions
        ? props.dimensions.mobile.height
        : "8vh",
    },
    backgroundColor: "#F5F5F5",
    zIndex: 10,
  })
);

const MenuList = styled(List)({
  padding: "3px",
});

const MenuListItem = styled(ListItemButton)((props: { isopen: boolean }) => ({
  padding: "0px",
  width: "fit-content",
  "@media (max-width: 768px)": {
    display: props.isopen ? "flex" : "none",
  },
}));
const MenuIcon = styled(ListItemIcon)({
  padding: "0px",
  width: "fit-content !important",
  minWidth: "8px !important",
});

const MenuText = styled(ListItemText)({
  marginLeft: "20px",
  marginTop: "0",
  marginBottom: "0",
});

const PbSideMenu = (props: PbSideMenuProps): JSX.Element => {
  return (
    <SideMenu
      isopen={props.isopen}
      position={props.position}
      dimensions={props.dimensions}
    >
      {props.routes.map((route) => {
        return route.hasAccess ? (
          <div key={"route-" + route.label}>
            <MenuList>
              <MenuListItem
                isopen={props.isopen}
                onClick={() => {
                  if (route.hasAccess) {
                    props.onRoute(route.path);
                  }
                }}
              >
                <ListItem>
                  <MenuIcon>
                    <route.icon />
                  </MenuIcon>
                  {props.isopen ? <MenuText>{route.label}</MenuText> : null}
                </ListItem>
              </MenuListItem>
            </MenuList>
            <Divider></Divider>
          </div>
        ) : (
          <></>
        );
      })}
      <OpenArrowRow isopen={props.isopen}>
        <OpenMenuArrow
          onClick={() => {
            props.onToggle();
          }}
          isopen={props.isopen}
          color="primary"
        ></OpenMenuArrow>
      </OpenArrowRow>
    </SideMenu>
  );
};

export default PbSideMenu;
